import gql from 'graphql-tag';

const recommendedProductsQuery = gql`
  fragment recommendedProducts on HealthProfile {
    recommendedProducts {
      type
      id
      productId
      catEntryId
      score
      name
      subtitle
      thumbnailUrl
      rrpPrice
      offerPrice
      offerText
      description
      associatedGoals {
        id
        name
        color
        iconUrl
        score
      }
      nutrients {
        name
        value
      }
    }
    goals {
      id
      name
      color
      iconUrl
      score
    }
  }
`;

export const GET_CONFIG = gql`
  query config {
    config {
      bundleInitialMaxItemCount
      catalogId
      storeId
      nutrientUpperLimits {
        id
        name
        value
      }
    }
  }
`;

export const GUEST_CREATE = gql`
  mutation guest_create {
    guest_create
  }
`;

export const filterProducts = gql`
  query healthProfile {
    healthProfile {
      ...recommendedProducts
      warnings {
        id
        name
      }
    }
  }
  ${recommendedProductsQuery}
`;

export const getLocalData = itemName => {
  return JSON.parse(localStorage.getItem(itemName));
};

export const setLocalData = (itemName, data) => {
  localStorage.setItem(itemName, JSON.stringify(data));
};
